module.exports = __webpack_public_path__ + "img/ID_BG_Icon.b87dc63a.svg";